import React, { useEffect, useState } from "react";
import MobileFooter from "../Common/components/PreLogin/MobileFooter";
import Terms from "../../routes/screens/Common/Terms";
import Privacy from "../../routes/screens/Common/Privacy";
import Cookies from "../../routes/screens/Common/Cookies";

const WhyLocalE = () => {
  const [section, setSection] = useState("");

  useEffect(() => {
    if (typeof document) {
      const mobileFooter = document.getElementById("mobile-footer");
      const desktopFooter = document.getElementById("desktop-footer");
      if (mobileFooter) {
        mobileFooter.classList.add("whylocale");
      }
      if (desktopFooter) {
        desktopFooter.classList.add("whylocale");
      }
    }
    return () => {};
  }, []);
  const renderSelectedSection = () => {
    if (section === "terms") {
      return <Terms onClickClose={() => setSection("")} />;
    } else if (section === "privacy") {
      return <Privacy onClickClose={() => setSection("")} />;
    } else if (section === "cookies") {
      return <Cookies onClickClose={() => setSection("")} />;
    } else {
      return <noscript />;
    }
  };
  return (
    (section && renderSelectedSection()) || (
      <>
        {/* Header */}
        <div className="head-general with-back visible-xs">
          <a
            onClick={() => {
              window.location.href = "/";
            }}
            className="back"
          >
            <img src="/png/chevron-left.png" />
          </a>
          <h4>Our Mission</h4>
          <a className="close"></a>
        </div>
        {/* Header */}
        <div className="whylocale-page white-bg">
          <div className="image-section-top">
            <div className="container">
              <div className="row">
                <div className="col-xs-12">
                  <h4>
                    Local high street shops <br/>
                    need your help.
                  </h4>
                </div>
              </div>
              {/* .row */}
            </div>
            {/* .container */}
          </div>

          <div className="tab-body">
            <div className="container">
              <div className="top-circle visible-xs">
                <img src="/svg/whylocale-top-circle.svg" />
              </div>
              <div className="tab1 section-1">
                <h4>
                  and that includes your favourite <br />
                  independent food heroes fighting against…
                </h4>
                <div className="flex-box">
                  <div className="section1">
                    <div className="whylocale-section-div">
                      <img src="/svg/why1.svg" />
                    </div>
                    <p>
                      High online commissions <br/>
                      of up to 35%.
                    </p>
                  </div>
                  <div className="right-circle visible-xs">
                    <img src="/svg/whylocale-right-circle.svg" />
                  </div>
                  <div className="section2">
                    <div className="whylocale-section-div">
                      <img src="/svg/why2.svg" />
                    </div>
                    <p>
                      Delivery only factory kitchens <br/>
                      with no high street shop front.
                    </p>
                  </div>
                  <div className="bottom-circle visible-xs">
                    <img src="/svg/whylocale-bottom-circle.svg" />
                  </div>
                  <div className="section3">
                    <div className="whylocale-section-div">
                      <img src="/svg/why3.svg" />
                    </div>
                    <p>
                      Online tech giants and <br/>
                      faceless national chains.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="image-section-bottom">
            <div className="container">
              <div className="row">
                <div className="col-xs-12"></div>
              </div>
              {/* .row */}
            </div>
            {/* .container */}
          </div>

          <div className="tab-body">
            <div className="container">
              <div className="tab1 section-2">
                <h4>
                  But! Together we can keep independent high
                  <br className="hide-xs"/>
                  street businesses open!
                </h4>
                {/*Desktop*/}
                <div className="section-group hide-xs">
                  {/*1*/}
                  <div
                    className="d-flex justify-content-around mt-50px"
                    style={{ height: "100px" }}
                  >
                    <div className="section1">
                      <div className="whylocale-section-div  mt-50px">
                        <img
                          style={{ width: "72.9px", height: "69.4px" }}
                          src="/svg/right-top-blue.svg"
                        />
                      </div>
                    </div>

                    <div className="section2">
                      <p>
                        An online food delivery platform<br /> 
                        that only supports <br />
                        quality independents.
                      </p>
                    </div>

                    <div className="section3">
                      <div className="whylocale-section-div  mt-50px">
                        <img
                          style={{ width: "72.9px", height: "69.4px" }}
                          src="/svg/right-bottom-blue.svg"
                        />
                      </div>
                    </div>
                  </div>
                  {/*2*/}
                  <div className="d-flex justify-content-around">
                    <div className="section1  mt-50px">
                      <p>
                        A vibrant local high <br/>
                        street and independent <br />
                        food community.
                      </p>
                    </div>

                    <div className="section2">
                      <div className="whylocale-section-div">
                        <img src="/gif/whylocale1.gif" />
                      </div>
                    </div>

                    <div className="section3  mt-50px">
                      <p>
                        Lower fees charged <br />
                        to our restaurant <br />
                        partners online.
                      </p>
                    </div>
                  </div>
                  {/*3*/}
                  <div className="d-flex justify-content-around">
                    <div className="section1">
                      <div className="whylocale-section-div">
                        <img
                          style={{ width: "72.9px", height: "69.4px" }}
                          src="/svg/left-top-blue.svg"
                        />
                      </div>
                    </div>

                    <div className="section2  mt-50px">
                      <p>
                        Reward eCoins for loyal <br />
                        locals with every delivery <br />
                        and collection order.
                      </p>
                    </div>

                    <div className="section3">
                      <div className="whylocale-section-div">
                        <img
                          style={{ width: "72.9px", height: "69.4px" }}
                          src="/svg/left-bottom-blue.svg"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {/*Desktop*/}
                {/*Mobile*/}
                <div className="section-group visible-xs">
                  <div className="gif-section">
                    <div className="whylocale-section-div">
                      <img src="/gif/whylocale1.gif" />
                    </div>
                  </div>
                  {/*1*/}
                  <div
                    className="d-flex justify-content-between first"
                    style={{ height: "100px" }}
                  >
                    <div className="section1">
                      <p>
                        An online food delivery platform that only supports
                        quality independents.
                      </p>
                    </div>

                    <div className="section1-arrow">
                      <div className="whylocale-section-div">
                        <img
                          style={{ width: "41px", height: "40px" }}
                          src="/svg/right-bottom-blue.svg"
                        />
                      </div>
                    </div>
                  </div>
                  {/*2*/}
                  <div
                    className="d-flex justify-content-between second"
                    style={{ height: "100px" }}
                  >
                    <div className="section2-arrow">
                      <div className="whylocale-section-div">
                        <img
                          style={{ width: "41px", height: "40px" }}
                          src="/svg/left-bottom-mobile.svg"
                        />
                      </div>
                    </div>
                    <div className="section2">
                      <p>
                        Lower fees charged to our restaurant partners online.
                      </p>
                    </div>
                  </div>
                  {/*3*/}
                  <div
                    className="d-flex justify-content-between third"
                    style={{ height: "100px" }}
                  >
                    <div className="section3">
                      <p>
                        Reward eCoins for loyal locals with every delivery and
                        collection order.
                      </p>
                    </div>
                    <div className="section3-arrow">
                      <div className="whylocale-section-div">
                        <img
                          style={{ width: "41px", height: "40px" }}
                          src="/svg/right-bottom-blue.svg"
                        />
                      </div>
                    </div>
                  </div>
                  {/*3*/}
                  <div className="d-flex last" style={{ height: "100px" }}>
                    <div className="section4">
                      <p>
                        A vibrant local high street
                        <br /> and independent food <br />
                        community.
                      </p>
                    </div>
                  </div>
                </div>
                {/*Mobile*/}

                <div className="bottom">
                  <p>
                    <strong style={{ color: "#1fb6ff" }}>Support</strong> Local
                  </p>
                  <p>
                    Order <strong style={{ color: "#1fb6ff" }}>Local E.</strong>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <MobileFooter
          openCookiesSection={() => setSection("cookies")}
          openPrivacySection={() => setSection("privacy")}
          openTermsSection={() => setSection("terms")}
        />
      </>
    )
  );
};

export default WhyLocalE;
